import Vue from "vue";
import VueRouter from "vue-router";
import router from "./router/router";
import ElementUI from "element-ui";
import "@/assets/js/axios/http_axios";
import "element-ui/lib/theme-chalk/index.css";
import common from "@/assets/js/comm.js";
import App from "./App.vue";
// import "default-passive-events";
import Print from "@/assets/js/common/print.js";
import Tools from "@/assets/js/tool.js";
import Api from "@/assets/js/API/api.js";
import comAPI from "@/assets/js/comAPI.js";
import "@/assets/css/base.less";
import directives from "@/assets/js/directives/directives";
//import { reloadVue } from './assets/js/Mixins/reload';
import MyImageUpload from "@/components/MyImageUpload";
import moment from "moment";
import { showLoading, hideLoading } from "@/assets/js/common/loading";
import AMap from "vue-amap";
import "@vuemap/vue-amap/dist/style.css";
import "@/assets/js/directives/permission";
import DeptTree from '@/components/DeptTree'

import 'vxe-table/lib/style.css'
import VXETable from 'vxe-table'
import VXETablePluginElement from 'vxe-table-plugin-element'
import XEUtils from 'xe-utils'

Vue.use(VXETable)
VXETable.use(VXETablePluginElement)
VXETable.setup({ XEUtils })

// import 'default-passive-events'
Vue.use(AMap);

// element弹出框拖动指令
import "@/assets/js/directives/dialog.js";
// 自定义打印系统需要
import { hiPrintPlugin } from "./print.js";

// 初始化vue-amap
AMap.initAMapApiLoader({
  // 高德key
  key: "af5465022ed36d747e5a0e8719cb0960",
  // 插件集合 （插件按需引入）
  plugin: [
    "AMap.Scale",
    "AMap.OverView",
    "AMap.ToolBar",
    "AMap.MapType",
    "AMap.PlaceSearch",
    "AMap.Geolocation",
    "AMap.Geocoder",
  ],
});
window._AMapSecurityConfig = {
  securityJsCode: "845d2b9bd90b95608858c5f4fa2f2cad", //申请key时的安全密钥
};

ElementUI.Dialog.props.closeOnClickModal.default = false;
Vue.use(VueRouter);
Vue.use(ElementUI);
Vue.use(Print);
Vue.use(directives);
Vue.use(hiPrintPlugin);
Vue.component("MyImageUpload", MyImageUpload);
Vue.component('DeptTree',DeptTree)

//Vue.mixin(reloadVue)

// 自定义打印系统需要
import Storage from "vue-ls";
let options = {
  namespace: "hiPrint-",
  name: "ls",
  storage: "local",
};
Vue.use(Storage, options);

function hasBtnPermission(permission) {
  if(common.isTest){
    return true
  }
  let PermissionArr = JSON.parse(sessionStorage.getItem("btnPermiss")) || [];
  PermissionArr.push("aaaaa");
  for(let i=0;i<PermissionArr.length;i++){
	  const item = PermissionArr[i]
	  if (item === permission) {
	    return true;
	  }
  }
  return false;
}
Vue.prototype.hasPermiss = hasBtnPermission;
Vue.prototype.$COMMON = common;
Vue.prototype.$API = Api;
Vue.prototype.$TOOLS = Tools;
Vue.prototype.$COMAPI = comAPI;
Vue.prototype.$showLoading = showLoading;
Vue.prototype.$hideLoading = hideLoading;
Vue.prototype.$moment = moment;

Vue.prototype.dealZeroWhileEmpty = (val) => {
  if (!val) {
    return 0;
  }
  return val;
};
Vue.prototype.dealNullWhileEmpty = (val) => {
  if (!val) {
    return null;
  }
  return val;
};

moment.locale("zh-CN");

// 对象类型检测
Vue.prototype.$getObject = function(v) {
  let s = Object.prototype.toString.call(v);
  if (s == "[object Object]") {
    return "Object";
  } else if (s == "[object Null]") {
    return "Null";
  } else if (s == "[object Number]") {
    return "Number";
  } else if (s == "[object Boolean]") {
    return "Boolean";
  } else if (s == "[object String]") {
    return "String";
  } else if (s == "[object Array]") {
    return "Array";
  } else if (s == "[object Date]") {
    return "Date";
  } else if (s == "[object Function]") {
    return "Function";
  } else if (s == "[object Undefined]") {
    return "Undefined";
  } else {
    return s;
  }
};

Vue.config.productionTip = false;

new Vue({
  el: "#app",
  router,
  render: (h) => h(App),
}).$mount("#app");
Vue.prototype.$keyBoard = function(vm, methodName, code) {
  document.onkeydown = function() {
    let key = window.event.keyCode;
    if (key == code) {
      vm[methodName](code); // 触发methodName事件
    }
  };
};
document.addEventListener("touchstart", function(e) {
  // do sth.
});
